import './App.css';
import { useContext } from 'react';
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import MainPage from './pages/MainPage/MainPage';
import Register from './pages/Register/Register';
import VerifyEmail from './pages/VerifyEmail/VerifyEmail';
import Profile from './pages/Profile/Profile';
import Library from './pages/Library/Library';
import Read from './pages/Read/Read';
import MyWorks from './pages/MyWorks/MyWorks';
import Bookmarks from './pages/Bookmarks/Bookmarks';
import Authors from './pages/Authors/Authors';
import Author from './pages/Author/Author';
import Discussions from './pages/Discussions/Discussions';
import Discussion from './pages/Discussions/Discussion';
import NewDiscussion from './pages/Discussions/NewDiscussion';
import WritingStation from './pages/WritingStation/WritingStation';
import Guidelines from './pages/Guidelines/Guidelines';
import Stats from './pages/Stats/Stats';
import Snackbar from './components/Snackbar/Snackbar';
import { AuthProvider } from './context/AuthContext';
import AuthContext from './context/AuthContext';
import SnackbarContext from './context/SnackbarContext';

function RequireAuth({ children }) {
  const { authTokens } = useContext(AuthContext);
  const location = useLocation();
  if (!authTokens) {
    return <Navigate to='/' replace state={{ from: location }} />;
  }
  return children;
}

function App() {

  const { isDisplayed } = useContext(SnackbarContext);

  return (
    <>
      {isDisplayed && <Snackbar />}

      <Routes>
        <Route element={<AuthProvider />}>
          <Route path='/' element={<MainPage />} />
          <Route path='/register' element={<Register />} />
          <Route path='/verify-email' element={<VerifyEmail />} />
          <Route path='/profile' element={<RequireAuth><Profile /></RequireAuth>} />
          <Route path='/library' element={<Library />} />
          <Route path='/authors' element={<Authors />} />
          <Route path='/author/:username' element={<Author />} />
          <Route path='/guidelines' element={<Guidelines />} />
          <Route path='/read/:id' element={<Read />} />
          <Route path='/discussions' element={<Discussions />} />
          <Route path='/discussions/new' element={<RequireAuth><NewDiscussion /></RequireAuth>} />
          <Route path='/discussions/:id' element={<Discussion />} />
          <Route path='/myworks' element={<RequireAuth><MyWorks /></RequireAuth>} />
          <Route path='/bookmarks' element={<RequireAuth><Bookmarks /></RequireAuth>} />
          <Route path='/writing' element={<RequireAuth><WritingStation /></RequireAuth>} />
          <Route path='/stats' element={<RequireAuth><Stats /></RequireAuth>} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
